export default __webpack_public_path__ + "static/hero737-342ab1c7343823a3263717249dfaf426.jpg";